import React from 'react';

export default function CityTags({ type, city = [], country }) {
  return (
    <div className={`tag-wrapper ${type}`}>
      <Choose>
        <When condition={type === 'single'}>
          <div>{country.name}</div>
        </When>
        <When condition={type === 'many'}>
          <div>{city.length === 1 ? city[0].name : `${city.length} cities`}</div>
        </When>
        <When condition={type === 'all'}>
          <div>All countries</div>
        </When>
      </Choose>
    </div>
  );
}
